import 'css-chunksrc/client/pages/projectPage/resourcesPage/sidebar/resourceTypesFilter/styles.scss';export default {
  "resourceTypesFilter": "_resourceTypesFilter_g8kn5_1",
  "icon": "_icon_g8kn5_5",
  "item": "_item_g8kn5_11",
  "name": "_name_g8kn5_41",
  "selected": "_selected_g8kn5_46"
};